import { render, staticRenderFns } from "./portraitTags.vue?vue&type=template&id=787637ba&scoped=true&"
import script from "./portraitTags.vue?vue&type=script&lang=js&"
export * from "./portraitTags.vue?vue&type=script&lang=js&"
import style0 from "./portraitTags.vue?vue&type=style&index=0&id=787637ba&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "787637ba",
  null
  
)

export default component.exports